module.exports = __webpack_public_path__ + "static/media/EditDisabledIcon.bf0fa84b.svg";